import { GlobalStatus,PackingStatus, ProductCategoryEnum, ShiftsDropDown, StockStatus, TransactionType } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { ForkLiftJobs } from "../fork-lift-jobs/fork-lift-jobs.entity";
import { Shifts } from "./shifts.enum";

@Entity('reporting')
export class StockIn {

  @PrimaryGeneratedColumn("increment",{name:'reporting_log_id'})
  reportingLogId:number;

  @Column("datetime", {
    nullable: true,
    name: "reporting_date"
    })
    reportingDate: Date;
  @Column("int",{
      nullable:false,
      name:"sale_order_id"
      })
  saleOrderId:number;
  @Column("int",{
      nullable:false,
      name:"sale_order_item_id"
      })
  saleOrderItemId:number;
  @Column("int",{
    nullable:false,
    default:0,
    name:"variant_id"
    })
    variantId:number;
    @Column("int",{
        nullable:false,
        default:0,
        name:"brand_id"
        })
        brandId:number;
        @Column({
            type: 'enum',
            enum: StockStatus,
            nullable: false,
            name: 'stock_type',
            default:"SaleOrder",
        })
        stockType: StockStatus;
    @Column("int",{
        nullable:false,
        default:0,
        name:"pack_style_id"
        })
        packStyleId:number;
  @Column("int",{
      nullable:false,
      name:"reported_cases"
      })
      reportedCases:number;
  @Column("int",{
      nullable:false,
      name:"loose_pouches"
      })
      loosePouches:number;
  @Column("int",{
      nullable:false,
      name:"pallet_id"
      })
      palletId:number;
  @Column("int",{
      nullable:false,
      default:0,
      name:"rack_postion"
      })
      rackPostion:number;
  @Column("varchar",{
      nullable:true,
      length:50,
      name:"reported_person"
      })
      reportedPerson:string;
  @Column("varchar",{
      nullable:false,
      length:50,
      name:"lot_code"
      })
      lotCode:string;
    @Column("int",{
        nullable:true,
        default:0,
        name:"trace_code"
        })
        traceCode:number;
    @Column("int",{
        nullable:true,
        default:0,
        name:"wh_incharge"
        })
        warehouseIncharge:number;
    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "remarks"
        })
    remarks: string;
    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
        })
      isActive:boolean;
      @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: true,
        name: 'pouches_shortage',
        default:PackingStatus.NO,
    })
    pouchesShortage: PackingStatus;
      @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: true,
        name: 'cartons_shortage',
        default:PackingStatus.NO,
    })
    cartonsShortage: PackingStatus;
//   @Column("int",{
//       nullable:false,
//       name:"receiving_plant"
//       })
//       receivingPlant:number;

    @Column({
        type: 'enum',
        enum: Shifts,
        nullable: false,
        name: 'shift',
        default:Shifts.general,
    })
    shift: Shifts;
    @Column({
        type: 'enum',
        enum: TransactionType,
        nullable: false,
        name: 'transaction_type',
        default:TransactionType.palleting,
    })
    transactionType: TransactionType;
    @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: false,
        name: 'packing_completed',
        default:PackingStatus.NO,
    })
    packingCompleted: PackingStatus;
    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "pallet_code"
        })
    palletCode: string;
    @Column("boolean",{
        nullable:false,
        default:false,
        name:"sync_status"
        })
      syncStatus:boolean;
    @Column("int",{
        nullable:true,
        name:"stock_id"
        })
        stockId?:number;
    @Column("int",{
        nullable:true,
        name:"store_consumption_id"
        })
        storeConsumptionId?:number;
    @Column("int", {
        nullable: false,
        name: "unit_id"
        })
        unitId: number;
        @Column("boolean",{
            nullable:false,
            default:false,
            name:"manual_reported"
            })
            manualReported:boolean;
    @Column("int", {
        nullable: false,
        default:0,
        name: "cold_storage_id"
        })
        coldStorageId: number;
    @Column("int", {
        nullable: true,
        default:0,
        name: "job_id"
        })
        jobId: number;
    @Column({
        type: 'enum',
        enum: ProductCategoryEnum,
        nullable: false,
        name: 'product_category',
        default:ProductCategoryEnum.g1,
    })
    productCategory: ProductCategoryEnum;
    // @Column("varchar",{
    //     nullable:false,
    //     length:50,
    //     name:"transaction"
    //     })
    //     transaction:string;
    // @Column("varchar",{
    //     nullable:false,
    //     length:50,
    //     name:"transaction_time"
    //     })
    //     transactionTime:string;
    @CreateDateColumn({
    name: "created_at",
    type:"datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        // default:"Admin",
        length:50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length:50
    })
    updatedUser: string | null;

    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
    @OneToMany(type => ForkLiftJobs, ForkLiftJobs => ForkLiftJobs.reportingInfo, { cascade: true })
    reportingInfo: ForkLiftJobs[];
}
